/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.filter('formatDate', () => (function(input) {
    const date_check = new RegExp('^[0-9]{2}-[01][0-9]-[0-9]{4}$');
    moment.locale('fr');
    if (input == null) { return ''; }
    if (!date_check.test(input)) { return input; }
    const date = moment(input, 'DD-MM-YYYY');
    if (date == null) { return ''; }
    return date.format('D MMMM YYYY');
}));
